<template>
    <table class="s-table-fee-type animation-opacity" border="0">
        <thead>
            <th>Tipo de empresa</th>
            <th>Acciones</th>
        </thead>
        <tbody>
            <tr
                v-for="(type_company, index) in listTypeCompany"
                :key="index"
            >
                <td class="s-table-fee-type__border-line text-center">
                    {{type_company.type_company}}</td>
                <td>
                    <div class="d-flex justify-center">
                        <OBtnOptionToolTipComp
                            smsTooltip="Actualizar tipo de empresa"
                            icon="mdi-lead-pencil"
                            style="margin:2px"
                            @click="$emit('clickupdate', type_company)"
                        />
                    </div>
                </td>
            </tr>
            <tr v-if="listTypeCompany.length==0" class="text-center">
                <td colspan="2">SIN DATOS</td>
            </tr>
        </tbody>
    </table>
</template>
<script>
import { OBtnOptionToolTipComp } from '../organisms'
export default {
    props: {
        listTypeCompany: Array
    },
    components: {
        OBtnOptionToolTipComp
    }
}
</script>